
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.996","height":"19.996"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M2.777 0h14.442A2.777 2.777 0 0120 2.777v14.442A2.777 2.777 0 0117.219 20H2.777A2.777 2.777 0 010 17.219V2.777A2.777 2.777 0 012.777 0z","transform":"translate(2 61.002)","fill":"#fff","stroke":"#e1e1e1"}})])]),_c('g',{attrs:{"fill":"#fcfdfd","stroke":"#2684ff","stroke-linejoin":"round","stroke-width":".8"}},[_c('g',{attrs:{"transform":"rotate(180 5.181 4.757)"}},[_c('rect',{attrs:{"width":"9.168","height":"3.056","rx":".8","stroke":"none"}}),_c('rect',{attrs:{"x":".4","y":".4","width":"8.368","height":"2.256","rx":".4","fill":"none"}})]),_c('path',{attrs:{"d":"M5.39 8.264l1.479 5.087a.062.062 0 00.117.004l.492-1.377 1.981 2.316 1.288-1.1-1.966-2.302 1.44-.246a.062.062 0 00.018-.116L5.484 8.19a.062.062 0 00-.095.074z","stroke-linecap":"round"}})])])
          )
        }
      }
    